import languages from 'Application/i18n/languages';

const defaultLanguage = languages.en;

export default defaultLanguage;
